export default __webpack_public_path__ + "images/inventory-active.svg";